import {
  SET_MERCHANT_ORDER,
  SET_MERCHANT_SHOPS,
  SET_MERCHANT_DINE,
  SET_MERCHANT_UNWIND,
  SET_MERCHANT_POPULAR,
  SET_MERCHANT_MODAL_DATA,
  SET_MERCHANT_MODAL_STATUS,
  SET_DISPLAY_MALL_WELCOME,
  SET_DISPLAY_APP_BANNER,
  SET_DISPLAY_APP_MODAL,
  SET_SELECTED_MALL_SLUG,
  SET_ZING_PARTNERS,
} from './actions/types'

const INITIAL_STATE = {
  orderShop: [],
  shop: [],
  dine: [],
  unwind: [],
  popular: [],
  showMerchantModal: false,
  merchantModalData: {},
  merchantModalStatus: null,
  displayMallWelcome: true,
  displayAppBanner: true,
  displayAppModal: false,
  zingPartners: [],
  selectedMallSlug:
    typeof window !== 'undefined' && window.localStorage
      ? localStorage.getItem('selectedMallSlug') || ''
      : '',
}

function setMerchantOrder(state, action) {
  return {
    ...state,
    orderShop: action.payload.orderShop,
  }
}
function setMerchantShop(state, action) {
  return {
    ...state,
    shop: action.payload.shop,
  }
}

function setMerchantDine(state, action) {
  return {
    ...state,
    dine: action.payload.dine,
  }
}

function setMerchantUnwind(state, action) {
  return {
    ...state,
    unwind: action.payload.unwind,
  }
}

function setMerchantPopular(state, action) {
  return {
    ...state,
    popular: action.payload.popular,
  }
}

function setMerchantModalData(state, action) {
  return {
    ...state,
    merchantModalData: action.payload.merchantModalData,
  }
}

function setMerchantModalStatus(state, action) {
  const { merchantModalStatus } = action.payload

  return {
    ...state,
    showMerchantModal: merchantModalStatus !== null,
    merchantModalStatus,
  }
}

function setDisplayMallWelcome(state, action) {
  return {
    ...state,
    displayMallWelcome: action.payload.displayMallWelcome,
  }
}

function setDisplayAppBanner(state, action) {
  return {
    ...state,
    displayAppBanner: action.payload.displayAppBanner,
  }
}

function setDisplayAppModal(state, action) {
  return {
    ...state,
    displayAppModal: action.payload.displayAppModal,
  }
}

function setSelectedMallSlug(state, action) {
  const { selectedMallSlug } = action.payload
  try {
    localStorage.setItem('selectedMallSlug', selectedMallSlug || '')
    // eslint-disable-next-line no-empty
  } catch (e) {}

  return {
    ...state,
    selectedMallSlug,
  }
}

const setZingPartners = (state, action) => ({
  ...state,
  zingPartners: action.payload.zingPartners,
})

function reducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case SET_MERCHANT_ORDER:
      return setMerchantOrder(state, action)
    case SET_MERCHANT_SHOPS:
      return setMerchantShop(state, action)
    case SET_MERCHANT_DINE:
      return setMerchantDine(state, action)
    case SET_MERCHANT_UNWIND:
      return setMerchantUnwind(state, action)
    case SET_MERCHANT_POPULAR:
      return setMerchantPopular(state, action)
    case SET_MERCHANT_MODAL_DATA:
      return setMerchantModalData(state, action)
    case SET_MERCHANT_MODAL_STATUS:
      return setMerchantModalStatus(state, action)
    case SET_DISPLAY_MALL_WELCOME:
      return setDisplayMallWelcome(state, action)
    case SET_DISPLAY_APP_BANNER:
      return setDisplayAppBanner(state, action)
    case SET_DISPLAY_APP_MODAL:
      return setDisplayAppModal(state, action)
    case SET_SELECTED_MALL_SLUG:
      return setSelectedMallSlug(state, action)
    case SET_ZING_PARTNERS:
      return setZingPartners(state, action)
    default:
      break
  }

  return state
}

export default reducer
